import React from 'react';
import { registry } from '../../core/Registry.js';

export function TextBlock({ node }) {
  const content = node.content || {};
  const text = content.text || 'Ersetze diesen Text mit deinem eigenen Inhalt.';

  return (
    <div style={{ margin: 0 }}>
      {text}
    </div>
  );
}

registry.register('TextBlock', {
  label: 'Textblock',
  icon: 'T',
  category: 'basic',
  component: TextBlock,
  defaultProps: {
    content: {
      text: 'Hier steht dein wunderbarer Text.'
    },
    style: {
      desktop: {
        color: '#4e5b73',
        fontSize: '16px',
        lineHeight: '1.6',
        marginBottom: '15px'
      }
    }
  },
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Inhalt',
          fields: [
            { name: 'content.text', type: 'text', label: 'Text' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Typografie',
          fields: [
            { name: 'style.desktop.color', type: 'color', label: 'Textfarbe' },
            { name: 'style.desktop.fontSize', type: 'text', label: 'Schriftgröße' },
            { name: 'style.desktop.lineHeight', type: 'text', label: 'Zeilenhöhe' },
            { name: 'style.desktop.textAlign', type: 'select', label: 'Ausrichtung', options: ['left', 'center', 'right', 'justify'] }
          ]
        }
      ]
    }
  ]
});
